/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./zrc/scripts/sections/logos-blog-instagram.js":
/*!******************************************************!*\
  !*** ./zrc/scripts/sections/logos-blog-instagram.js ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @shopify/theme-sections */ \"./node_modules/@shopify/theme-sections/theme-sections.js\");\n/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! swiper */ \"./node_modules/swiper/swiper.esm.js\");\n\n\nvar sectionType = 'logos-blog-instagram-section';\nvar sectionConfig = {\n  onLoad() {\n    this.initCarousel();\n    this.initInstagramPosts();\n  },\n  initCarousel() {\n    var $slider = this.container.querySelector('.lbi-logos-carousel');\n    var slidesCount = parseInt($slider.dataset.slides, 10);\n    var carouselConfig = {\n      modules: [swiper__WEBPACK_IMPORTED_MODULE_1__.Navigation],\n      loop: slidesCount > 2,\n      spaceBetween: 15,\n      slidesPerGroup: 1,\n      slidesPerView: 2,\n      longSwipesRatio: 0.01,\n      resistanceRatio: 0.01,\n      enabled: slidesCount > 2,\n      navigation: {\n        nextEl: '.lbi-logos-navigation.next',\n        prevEl: '.lbi-logos-navigation.prev'\n      },\n      breakpoints: {\n        581: {\n          slidesPerView: 3,\n          spaceBetween: 15,\n          slidesPerGroup: 1\n          // enabled: slidesCount > 3,\n        },\n        741: {\n          slidesPerView: 4,\n          spaceBetween: 20,\n          slidesPerGroup: 1\n          // enabled: slidesCount > 4,\n        },\n        1024: {\n          slidesPerView: 5,\n          spaceBetween: 20,\n          slidesPerGroup: 1\n          // enabled: slidesCount > 5,\n        },\n        1440: {\n          slidesPerView: 6,\n          spaceBetween: 20,\n          slidesPerGroup: 1\n          // enabled: slidesCount > 6,\n        }\n      }\n    };\n    this.carousel = new swiper__WEBPACK_IMPORTED_MODULE_1__.default($slider, carouselConfig);\n  },\n  onBlockSelect(event) {\n    var currentSlide = parseInt(event.srcElement.dataset.swiperSlideIndex, 10);\n    this.carousel.slideToLoop(currentSlide);\n  },\n  initInstagramPosts() {\n    // Función que inicializa los post de instagram, donde extraemos las imagenes del widget y creamos nuestra propia lista.\n\n    // Buscamos el widget y la lista donde podremos nuestros post construidos\n    var $target = this.container.querySelector('#insta-feed');\n    var $newImagesContainer = this.container.querySelector('.lbi-instagram-images-list');\n    var $instagramHeader = this.container.querySelector('.lbi-instagram-header');\n    var $instagramImages = this.container.querySelector('.lbi-instagram-images-wrapper');\n    var $instagramRow = this.container.querySelector('.lbi-instagram-row');\n    var instagramLink = $newImagesContainer.dataset.link;\n    var observer = new window.MutationObserver(() => {\n      // buscamos las imagenes dentro del widget\n      var imagesFormWidget = $target.querySelectorAll('.instafeed-container');\n\n      // si no hay, o no existen post, o no a cargado completo el widget, entonces no hacemos nada\n      if (imagesFormWidget.length === 0) {\n        return;\n      }\n\n      // recorremos todas las imagenes del widget\n      imagesFormWidget.forEach(($imageWrapper, index) => {\n        // solo haremos 4 post\n        if (index >= 4) {\n          return;\n        }\n\n        // Obtenemos la url de la imagenm y el texto descriptivo\n        var imageUrl = $imageWrapper.querySelector('img').dataset.src;\n        var imageAlt = $imageWrapper.querySelector('img').alt;\n\n        // construimos la imagen\n        var image = document.createElement('img');\n        image.setAttribute('src', imageUrl);\n        image.setAttribute('alt', imageAlt);\n        image.setAttribute('loading', 'lazy');\n\n        // construimos en enlace\n        var link = document.createElement('a');\n        link.setAttribute('href', instagramLink);\n        link.setAttribute('target', '_blank');\n        link.append(image);\n\n        // cosntruimos el item list\n        var listItem = document.createElement('li');\n        listItem.append(link);\n\n        // ponemos en el DOM lo construido anteriormente\n        $newImagesContainer.append(listItem);\n      });\n\n      // Mostramos la sección\n      $instagramHeader.classList.remove('hidden');\n      $instagramImages.classList.remove('hidden');\n      $instagramRow.classList.remove('no-images');\n\n      // dejamos de observar al widget una vez que terminamos de hacer nuestras propias imagenes\n      observer.disconnect();\n    });\n\n    // Observamos el widget\n    observer.observe($target, {\n      childList: true\n    });\n  }\n};\n\n// Se determina si ya se ha registrado la seccióno no.\nif (_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__.registered[sectionType] == null) {\n  (0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__.register)(sectionType, sectionConfig);\n}\n\n//# sourceURL=webpack://getmore-workflow/./zrc/scripts/sections/logos-blog-instagram.js?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/******/ 	// the startup function
/******/ 	// It's empty as some runtime module handles the default behavior
/******/ 	__webpack_require__.x = x => {};
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// Promise = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"logos-blog-instagram": 0
/******/ 		};
/******/ 		
/******/ 		var deferredModules = [
/******/ 			["./zrc/scripts/sections/logos-blog-instagram.js","commons"]
/******/ 		];
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		var checkDeferredModules = x => {};
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime, executeModules] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0, resolves = [];
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					resolves.push(installedChunks[chunkId][0]);
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			while(resolves.length) {
/******/ 				resolves.shift()();
/******/ 			}
/******/ 		
/******/ 			// add entry modules from loaded chunk to deferred list
/******/ 			if(executeModules) deferredModules.push.apply(deferredModules, executeModules);
/******/ 		
/******/ 			// run deferred modules when all chunks ready
/******/ 			return checkDeferredModules();
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkgetmore_workflow"] = self["webpackChunkgetmore_workflow"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 		
/******/ 		function checkDeferredModulesImpl() {
/******/ 			var result;
/******/ 			for(var i = 0; i < deferredModules.length; i++) {
/******/ 				var deferredModule = deferredModules[i];
/******/ 				var fulfilled = true;
/******/ 				for(var j = 1; j < deferredModule.length; j++) {
/******/ 					var depId = deferredModule[j];
/******/ 					if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferredModules.splice(i--, 1);
/******/ 					result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 				}
/******/ 			}
/******/ 			if(deferredModules.length === 0) {
/******/ 				__webpack_require__.x();
/******/ 				__webpack_require__.x = x => {};
/******/ 			}
/******/ 			return result;
/******/ 		}
/******/ 		var startup = __webpack_require__.x;
/******/ 		__webpack_require__.x = () => {
/******/ 			// reset startup function so it can be called again when more startup code is added
/******/ 			__webpack_require__.x = startup || (x => {});
/******/ 			return (checkDeferredModules = checkDeferredModulesImpl)();
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	// run startup
/******/ 	__webpack_require__.x();
/******/ })()
;